import React from "react";
import { useTranslation } from "react-i18next";
import { ShieldAlert } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogBody,
  DialogFooter,
  DialogTitle,
} from "@/components/ui/Dialog";
import Button from "@/components/ui/Button";

interface AssetAccessRequiredDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function AssetAccessRequiredDialog({ open, onClose }: AssetAccessRequiredDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent size="sm">
        <DialogBody className="flex flex-col items-center text-center gap-4 pt-8">
          <div className="w-12 h-12 rounded-full bg-amber-50 flex items-center justify-center">
            <ShieldAlert className="w-6 h-6 text-amber-600" />
          </div>
          <div className="space-y-1.5">
            <DialogTitle>{t("assets.accessRequired.title")}</DialogTitle>
            <p className="text-sm text-muted-foreground">{t("assets.accessRequired.body")}</p>
          </div>
        </DialogBody>
        <DialogFooter className="justify-center">
          <Button onClick={onClose} data-testid="asset-access-required-ok">
            {t("assets.accessRequired.action")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
